<template>
  <div :class="['FieldUpload', { error: canShowError }]">
    <field-label v-if="label" :for-id="id">{{ label }}</field-label>
    <label :class="['field', { filled }]">
      <input
        :id="id"
        :name="name"
        type="file"
        :accept="accept || null"
        @change="onChange"
      />
      <span class="cta">{{ cta }}</span>
      <span class="file-label">{{ fileLabel }}</span>
    </label>
    <field-error :show="canShowError">{{ errorMessage }}</field-error>
  </div>
</template>

<script>
import formField from "@mixins/form-field";
import FieldLabel from "@components/form/field-label";
import FieldError from "@components/form/field-error";

export default {
  name: "FieldUpload",
  components: { FieldError, FieldLabel },
  mixins: [formField],
  props: {
    placeholder: { type: String, required: true },
    cta: { type: String, required: true },
    accept: { type: String, default: "" }
  },
  computed: {
    filled() {
      return !!this.field.$model;
    },
    fileLabel() {
      if (this.field.$model) {
        return this.field.$model.name;
      }
      return this.placeholder;
    }
  },
  methods: {
    onChange(e) {
      if (e.target.files && e.target.files[0]) {
        this.field.$model = e.target.files[0];
      } else {
        this.field.$model = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.field {
  display: flex;
  align-items: center;
  width: 100%;
  background: $color-white;
  border: 1px solid rgba($color-dark, 0.25);
  border-radius: 5px;
  font-size: 16px;
  line-height: normal;
  font-weight: $light;
  height: 40px;
  padding: 0 16px 0 4px;
  color: rgba($color-grey, 0.75);
  transition: border 0.4s ease-in-out;
  position: relative;
  cursor: pointer;

  > input {
    position: absolute;
    top: 0;
    left: -5000px;
  }

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
    height: 50px;
    padding-left: 10px;
  }

  &.filled {
    color: $color-dark;
  }

  .error & {
    border-color: $color-error;
  }
}

.cta {
  margin-right: 16px;
  background: $color-blue-lochmara;
  color: $color-white;
  border-radius: 5px;
  font-size: 16px;
  line-height: 1;
  padding: 8px 12px;
  font-weight: $bold;
  white-space: nowrap;
  transition: background-color 0.3s ease-in-out;

  .field:hover & {
    background-color: darken($color-blue-lochmara, 10%);
  }
}

.file-label {
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
